// extracted by mini-css-extract-plugin
module.exports = {"prizeName":"InstantLotteryConfirmation_prizeName___aWrg"};